
import Vue from 'vue'

export default Vue.extend({
  name: 'Sign-in-up-common',
  components: {},
  data: () => ({}),
})
